import { Component, Optional } from '@angular/core';
import { BaseViewComponent, DesignBlockImageScope, DesignBlockScope, WebsiteBlockImageAction, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';
import { WebsiteBlockImageDirective } from '../directives/website-block-image.directive';

@Component({
    selector: 'lib-image-action-menu',
    templateUrl: './image-action-menu.component.html',
    styleUrls: ['./image-action-menu.component.scss']
})
export class ImageActionMenuComponent extends BaseViewComponent {
    Scope = this.SetScope({
        Requires: [DesignBlockImageScope, DesignBlockScope, WebsitePageScope]
    });

    private _hasSwap: boolean = false;
    private _isCarousel: boolean = false;
    private _noDelete: boolean = false;

    constructor(@Optional() private _WebsiteBlockImageDirective: WebsiteBlockImageDirective) {
        super();
        if (!this._WebsiteBlockImageDirective) {
            throw Error('ImageActionMenuComponent must be in the scope of a websiteBlockImage directive');
        }
    }

    override ngOnInit() {
        super.ngOnInit();

        if (!(WebsiteBlockDisplayItem.HasImages(this.websiteBlockData))) {
            throw Error('ImageActionMenuComponent used in wrong context');
        }

        if (WebsiteBlockDisplayItem.IsTextAndMedia(this.Scope.websiteBlockData)) {
            this._isCarousel = this.Scope.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryCarousel
                            || this.Scope.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryCarouselOverlay;

            this._hasSwap = this._isCarousel || WebsiteBlockTextAndMediaDisplayItem.IsGalleryBlock(this.Scope.websiteBlockData);

            this._noDelete = this.Scope.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryGrid;
        }
    }

    ImageActionClicked(action: WebsiteBlockImageAction): void {
        const index = this.websiteBlockData.Images.indexOf(this.Scope.imageData);
        this.Scope.HandleImageAction(this.websiteBlockData, action, index);
    }

    get hasDetails(): boolean {
        return !!this.Scope.imageData.WebsiteMediaLibraryItemID;
    }

    get hasSwap(): boolean {
        return this._hasSwap;
    }

    get swapDisabled(): boolean {
        return (this._isCarousel && !this.hasDetails) || this.websiteBlockData.Images.length <= 1;
    }

    get deleteDisabled(): boolean {
        return (this._isCarousel && !this.hasDetails) || this.websiteBlockData.Images.length <= (this._isCarousel ? 3 : 1);
    }

    get showActionMenu(): boolean {
        return this._WebsiteBlockImageDirective.showActionMenu;
    }

    get websiteBlockData(): WebsiteBlockDisplayItem.WithImages {
        return this.Scope.websiteBlockData as WebsiteBlockDisplayItem.WithImages;
    }

    get WebsiteBlockImageAction(): typeof WebsiteBlockImageAction {
        return WebsiteBlockImageAction;
    }

    get noDelete(): boolean {
        return this._noDelete;
    }
}
